export const categories = [
  {
    key: 'drama',
    name: '剧情',
    description: '长篇剧情作品，讲述完整的男同情感故事与人生际遇。',
    icon: 'ri-film-line',
  },
  {
    key: 'short',
    name: '短片',
    description: '精炼短片合集，用几个镜头捕捉真实而动人的瞬间。',
    icon: 'ri-movie-2-line',
  },
  {
    key: 'special',
    name: '专题',
    description: '专题策划与深度内容，梳理男同影像文化的脉络与记忆。',
    icon: 'ri-stack-line',
  },
];